import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  getLocationPrograms as getLocationProgramsApi,
  getInstitutionDetails as getInstitutionDetailsApi,
} from "../api/kindergartenApi";

export interface InstitutionState {}

let initialState: InstitutionState = {};

export const getLocationPrograms = createAsyncThunk(
  "institution/getLocationPrograms",
  async ({
    pedagogicalYearInstitutionId,
    parentIntitutionId,
    programAgeId,
    programDurationId,
    programId,
    requestTypeId,
  }: {
    pedagogicalYearInstitutionId: number;
    parentIntitutionId?: number;
    programAgeId?: number;
    programDurationId?: number;
    programId?: number;
    requestTypeId?: number;
  }) => {
    const response = await getLocationProgramsApi(
      pedagogicalYearInstitutionId,
      parentIntitutionId,
      programAgeId,
      programDurationId,
      programId,
      requestTypeId
    );
    return response;
  }
);

export const getInstitutionDetalis = createAsyncThunk(
  "institution/searchInstitutionDetalis",
  async (pedagogicalYearInstitutionId: number) => {
    const response = await getInstitutionDetailsApi(
      pedagogicalYearInstitutionId
    );
    return response;
  }
);

const institutionSlice = createSlice({
  name: "institution",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export default institutionSlice.reducer;
